export const GET_TABLES_ERROR = "redux_store:tables.error.get";
export const ADD_TABLE_ERROR = "redux_store:tables.error.add";
export const DELETE_TABLE_ERROR = "redux_store:tables.error.delete";
export const UPDATE_TABLE_ERROR = "redux_store:tables.error.update";

export const GET_TABLELINKS_ERROR = "redux_store:tables.error.get_links";
export const ADD_TABLELINK_ERROR = "redux_store:tables.error.add_link";
export const DELETE_TABLELINK_ERROR = "redux_store:tables.error.delete_link";
export const UPDATE_TABLELINK_ERROR = "redux_store:tables.error.update_link";

export const GET_TABLE_TYPES_ERROR = "redux_store:tables.error.get_types";



// WEBPACK FOOTER //
// ./src/errors/tables.js